import React, { useState } from 'react';
import '../App.css';

function Faq() {
  const [faqs, setFaqs] = useState([
    {
      question: 'What services do you offer?',
      answer: 'Our services include design and construction of the mandiram, lighting and fixtures, wood staining and finishing and custom accessories', 
      open: false
    },
    {
      question: 'How do I pay for this?',
      answer: 'The initial consultation for the design of the mandiram is free. Once we have agreed upon a design, our team will get back to you with an invoice detailing the cost of materials required and the cost of labor. The payment for the materials will need to be made at that time to start work on the mandiram. The final remaining payment will be required upon delivery.', 
      open: false
    },
    {
      question: 'What types of wood do you use for the mandirs?',
      answer: 'We use a variety of high-quality woods for our custom mandirs, including teak, rosewood, and mahogany, among others. We source our materials sustainably and can provide specific types of wood upon request.', 
      open: false
    },
    {
      question: 'Can I customize the size and design of my mandir?',
      answer: 'Absolutely! We pride ourselves on creating mandirs that are tailored to your specific space requirements and design preferences. You can choose from our range of existing designs or work with our artisans to create something completely unique.', 
      open: false
    },
    {
      question: 'I have no idea what or how to design a mandir. How can you help me?',
      answer: 'Not to worry at all! If you look at our gallery, you can see some of the designs we have already made. You can always choose something from that. Or if you would like a consultation, we can also do that at no extra cost to you!', 
      open: false
    },
    {
      question: 'How long does it take to build and deliver a custom mandir?',
      answer: 'The time it takes to build and deliver your custom mandir can vary depending on the complexity of the design and our current order volume. Typically, it takes between 6 to 8 weeks from design approval to delivery. Any unforseen delays would be communicated immediately.', 
      open: false
    },
    {
      question: 'What is your return policy for custom mandirs?',
      answer: 'Unfortunately since all of our mandirs are custom made, we do not offer returns. However, if there are any issues upon delivery or if the mandir is damaged during shipping, please contact us immediately to resolve the situation.', 
      open: false
    },
    {
      question: 'Do you do shipping? How is that handled?',
      answer: 'Due to the mandirams being intricately designed and stained, we do not offer shipping currently. However, we do deliveries within a 50 mile radius', 
      open: false
    },
    {
      question: 'How can I contact customer support?',
      answer: 'You can contact us via email at jayswoodworks2@gmail.com, send us a message on any of our social media platforms or just use the form below.', 
      open: false
    },
    // Add more FAQs here
  ]);

  const toggleFAQ = index => {
    setFaqs(faqs.map((faq, i) => {
      if (i === index) {
        faq.open = !faq.open;
      } else {
        faq.open = false;
      }

      return faq;
    }));
  };

  return (
    <div className="faq-main">
      <h1>FAQ</h1>
      <div className="faqs">
        {faqs.map((faq, index) => (
          <div
            className={`faq ${faq.open ? 'open' : ''}`}
            key={index}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              {faq.question}
            </div>
            <div className="faq-answer">
              {faq.answer}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faq;
